import { render, staticRenderFns } from "./DataQualityStats.vue?vue&type=template&id=70e6a28d&scoped=true&"
import script from "./DataQualityStats.vue?vue&type=script&lang=js&"
export * from "./DataQualityStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6a28d",
  null
  
)

export default component.exports